module.exports = __webpack_public_path__ + "static/media/get_insured_carousel_2.74eab738.svg";